module.exports = __webpack_public_path__ + "img/arrow.6237356e.svg";